import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import OptimizedImage from "@/components/OptimizedImage";
import Reveal from "@/components/Reveal";

export default function LandingPage() {
  return (
    <Layout>
      {/* Hero — meet the author */}
      <header className="hero">
        <div className="container hero-grid">
          <div>
            <div className="hero-kicker">AUTHOR &amp; CREATOR OF TRANSFORMATION SYSTEMS</div>
            <h1 className="hero-title">
              MEET RAJESH SIVACHARYA <br />
              <span className="text-gold">AUTHOR • CREATOR • TRANSFORMATION GUIDE</span>
            </h1>
            <blockquote style={{ fontFamily: "var(--font-serif)", fontSize: "1.4rem", color: "var(--gold-warm)", margin: "20px 0", borderLeft: "3px solid var(--gold-warm)", paddingLeft: "20px", fontStyle: "italic" }}>
              "What if the life you're living is not the only life you're capable of creating?"
            </blockquote>
            <p className="hero-subtitle">
              I write about the patterns, beliefs, identities, and choices that shape the life we create—and the practical systems that can help us change them.
            </p>
          </div>

          <div style={{ textAlign: "center" }}>
            <OptimizedImage
              src="/assets/author/rajesh-hero.png"
              alt="Rajesh Sivacharya — Author & Creator of Transformation Systems, with the Identity Shift collection and Rich by Thirty"
              width={1024}
              height={1536}
              priority
              style={{ width: "100%", maxWidth: "460px", height: "auto", borderRadius: "var(--radius-xl)", border: "1px solid var(--border-gold)", boxShadow: "0 20px 50px rgba(0,0,0,0.6)" }}
            />
          </div>
        </div>
      </header>

      {/* Two Worlds Split — choose a transformation pathway */}
      <Reveal as="section" className="container section-padding" style={{ borderTop: "1px solid var(--border-glass)" }}>
        <div style={{ textAlign: "center", maxWidth: "760px", margin: "0 auto 20px auto" }}>
          <div className="hero-kicker">TWO TRANSFORMATION PATHWAYS</div>
          <h2 style={{ fontSize: "2.8rem" }}>CHOOSE YOUR TRANSFORMATION WORLD</h2>
          <p style={{ color: "var(--text-secondary)", fontSize: "1.05rem" }}>
            Two distinct transformation pathways under one author brand.
          </p>
        </div>

        <div className="world-split-grid">
          <div className="world-card">
            <div>
              <div className="world-tag">WORLD 1 — PERSONAL TRANSFORMATION</div>
              <h3 className="world-title font-serif" style={{ color: "var(--gold-warm)" }}>THE IDENTITY SHIFT™</h3>
              <div className="world-subtitle">3 Books · 4 Guided Journals · Daily Practice Kit</div>
              <p className="world-desc">
                Understand the patterns behind your life. Rewire the beliefs and identity beneath them. Practice a different way of thinking, choosing, and acting through structured 30-day practices.
              </p>
            </div>
            <div>
              <Link to="/identity-shift" className="btn btn-primary-gold" style={{ width: "100%" }}>
                EXPLORE THE IDENTITY SHIFT™ →
              </Link>
            </div>
          </div>

          <div className="world-card">
            <div>
              <div className="world-tag">WORLD 2 — CAREER &amp; FINANCIAL TRANSFORMATION</div>
              <h3 className="world-title font-serif" style={{ color: "var(--gold-warm)" }}>CAREER &amp; WEALTH</h3>
              <div className="world-subtitle">Rich by Thirty, Broke by Thirty</div>
              <p className="world-desc">
                Build a stronger financial foundation from your first paycheck, avoid the debt trap, and create a long-term path toward wealth and financial freedom. Written specifically for young salaried professionals.
              </p>
            </div>
            <div>
              <Link to="/career-wealth" className="btn btn-primary-gold" style={{ width: "100%" }}>
                EXPLORE CAREER &amp; WEALTH →
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </Layout>
  );
}
